import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../context/authProvider";
import GMTIcon from "../../../img/svg/gmtIcon";
import { CloseIcon, MenuLineIcon } from "../../../img/svg/adminIcons";
import SideBar from "./sideBar";

// barra superior do mobile/tablet (< lg) com o menu em drawer lateral
export default function AdminHeader() {

    const { user } = useAuth();
    const { pathname } = useLocation();

    const [bar, setBar] = useState(false);

    // fecha o drawer ao trocar de tela
    useEffect(() => {
        setBar(false);
    }, [pathname]);

    useEffect(() => {
        if (!bar) {
            return;
        }
        document.body.style.overflow = "hidden";
        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                setBar(false);
            }
        }
        window.addEventListener("keydown", onKeyDown);
        return () => {
            document.body.style.overflow = "";
            window.removeEventListener("keydown", onKeyDown);
        }
    }, [bar]);

    return (
        <>
            <header className="lg:hidden sticky top-0 z-30 flex h-14 items-center justify-between gap-3 bg-primary px-2 text-white shadow-md">
                <button type="button" onClick={() => setBar(true)} aria-label="Abrir menu" className="flex h-10 w-10 items-center justify-center rounded-lg hover:bg-white/10">
                    <MenuLineIcon width="22px" />
                </button>
                <Link to="/admin" aria-label="Início do painel">
                    <GMTIcon width="84px" fill="#fff" />
                </Link>
                <span title={user?.email} className="mr-1 flex h-9 w-9 items-center justify-center rounded-full bg-secondary text-sm font-bold uppercase">
                    {(user?.name || user?.email || "?").charAt(0)}
                </span>
            </header>
            {
                bar ?
                    <div className="lg:hidden fixed inset-0 z-40 font-lato" role="dialog" aria-modal="true" aria-label="Menu do painel">
                        <div onClick={() => setBar(false)} className="absolute inset-0 bg-gray-950/60 animate-admin-fade motion-reduce:animate-none" />
                        <div className="absolute inset-y-0 left-0 w-[85%] max-w-[300px] shadow-2xl animate-admin-drawer motion-reduce:animate-none">
                            <SideBar onNavigate={() => setBar(false)} />
                            <button type="button" onClick={() => setBar(false)} aria-label="Fechar menu" className="absolute top-3 right-3 flex h-10 w-10 items-center justify-center rounded-lg text-gray-400 hover:bg-white/10 hover:text-white">
                                <CloseIcon />
                            </button>
                        </div>
                    </div>
                    : null
            }
        </>
    )
}
